import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Schema from 'AppReact/schema';
import { CalendarIcon, Input } from './atoms';
import { BodyWrapper, MarginRightWrapper } from './wrappers';
import { Text, Label } from 'atoms'
import { FilterHeaderWrapper, StaticWrapper, FlexCenterWrapper } from 'wrappers';
import { CalendarSvg } from 'components/icons';
import Calendar from 'containers/calendar';
import Controller from './controller';
import { format } from 'date-fns';
import internalState from './internalState';

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: 'DateRangeSelector',
  controller: Controller,
  initialProps: ({ startDate, endDate, scrollLeft, disabledBefore }) => ({ startDate, endDate, disabledBefore, left: scrollLeft !== null ? ((headerRef?.current?.offsetLeft ?? 0) - (scrollLeft ?? 0)) : null }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'Selector',
      isButton: true,
      ref: headerRef,
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'Inputs',
          elements: [
            {
              component: Label,
              name: 'Label',
              displayValue: () => 'Date range: ',
              bindings: ({ }) => ({})
            },
            {
              component: Input,
              name: 'StartDateInput',
              bindings: ({ startDateEntry, startDate, endDate }) => ({ endDate, value: startDateEntry || (startDate ? format(startDate, 'MM/dd/yyyy') : ''), placeholder: 'Start Date' })
            },
            {
              component: Text,
              displayValue: () => '-',
              bindings: ({ }) => ({})
            },
            {
              component: Input,
              name: 'EndDateInput',
              bindings: ({ endDateEntry, endDate, startDate }) => ({ startDate, value: endDateEntry || (endDate ? format(endDate, 'MM/dd/yyyy') : ''), placeholder: 'End Date' })
            }
          ]
        },
        {
          name: 'CalendarIcon',
          component: CalendarIcon,
          displayValue: () => <CalendarSvg />,
          bindings: ({ }) => ({}),
        }
      ]
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      displayState: ({ left }) => ({ left }),
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: wrap(Calendar, MarginRightWrapper),
          name: 'StartCalendar',
          bindings: ({ startDate, endDate, disabledBefore }) => ({
            selectedDate: startDate,
            selectedPeriod: startDate && endDate ? [startDate, endDate] : [],
            disabledAfter: endDate,
            disabledBefore: disabledBefore
          })
        },
        {
          component: Calendar,
          name: 'EndCalendar',
          bindings: ({ startDate, endDate }) => ({
            selectedDate: endDate,
            selectedPeriod: startDate && endDate ? [startDate, endDate] : [],
            disabledBefore: startDate,
          })
        }
      ]
    }
  ]
};

const DateRangeSelector = ContainerComponent(definition)

export default wrap(DateRangeSelector, StaticWrapper);